<template>
  <div class="midia-kpis-page">

    <div class="box-filter">

      <div class="hero__line hero__period" v-if="kpis">
        <span><b>Período:</b> {{ shortRange(safeKpis.period.start, safeKpis.period.end) }}</span>
        <span class="dot">•</span>
        <span class="muted">Comparando com: {{ shortRange(safeKpis.previous.period.from, safeKpis.previous.period.to) }}</span>
      </div>

      <div class="box-filter__childs">
        <!-- <FilterAffiliate @changeAffiliate="changeAffiliate" :selectMultiple="false" /> -->
        <FilterCampaigns :selectMultiple="false" @onChange="changeCampaigns"/>
        <FilterDatepicker @getDataSelect="setDataFilter" />
      </div>
    </div>

    <!-- Loading / Empty state -->
    <div v-if="!kpis" class="empty-state">
      <div class="panel">
        <div class="panel__header">
          <h2>Conecte e selecione a conta de Ads</h2>
        </div>
        <div class="panel__body">
          <p>
            Assim que a conta estiver selecionada e houver dados no período, os KPIs aparecem aqui.
          </p>
        </div>
      </div>
    </div>

    <div v-else>
      <!-- HERO AHA -->
      <div class="hero-grid">
        <!-- ROAS Card -->
        <div class="hero">
          <div class="hero__top">
            <div class="hero__left panel">
              <div class="">
                <div class="panel__header row-between">
                  <div class="hero__label">
                    <i class="pi pi-megaphone text-green"></i> ROAS
                  </div>
                  <button class="link-btn" @click="openHelp('roas')">O que é ROAS?</button>
                </div>
                <div class="hero__value-row">
                  <div class="hero__value">
                    {{ formatNumber(safeKpis.current.roas, 2) }}
                  </div>

                  <span
                    v-if="safeKpis.delta && safeKpis.delta.roas_pct !== null"
                    class="delta-badge"
                    :class="deltaBadgeClass('roas', safeKpis.delta.roas_pct)"
                    :title="'vs período anterior comparável'"
                  >
                    <i :class="deltaSymbolClass('roas', safeKpis.delta.roas_pct)"></i>
                    {{ formatSignedPct(safeKpis.delta.roas_pct) }}
                  </span>

                  <div class="hero__sub">
                    <i class="pi pi-sparkles"></i> Para cada <b>R$ 1</b> investido, voltou <b>R$ {{ formatNumber(safeKpis.current.roas || 0, 2) }}</b>
                  </div>
                </div>
              </div>

              <div class="hero__points">
                <div class="kpi kpi--transparent">
                  <div class="kpi__head">
                    <span class="kpi__title"><i class="pi pi-dollar"></i> Receita <ActiveIntegrationsIcons small :only="safeKpis.current.with_sales == true ? 'ecommerce' : 'ads'" /></span>
                  </div>
                  <div class="kpi__value">
                    {{ safeKpis.current.revenue | numberToReal }}
                  </div>
                </div>

                <div class="kpi kpi--transparent">
                  <div class="kpi__head">
                    <span class="kpi__title"><i class="pi pi-credit-card"></i> Investimento <ActiveIntegrationsIcons small only="ads" /></span>
                  </div>
                  <div class="kpi__value">
                    {{ safeKpis.current.cost | numberToReal }}
                  </div>
                </div>

                  
                <!-- <div class="panel">
                  <div class="hero__label">
                    <i class="pi pi-database"></i> Investimento
                  </div>
                  <div class="hero__value">
                    {{ safeKpis.current.cost | numberToReal }}
                  </div>
                </div>
                <div class="panel">
                  <div class="hero__label">
                    <i class="pi pi-megaphone text-green"></i> Receita
                  </div>
                  <div class="hero__value">
                    {{ safeKpis.current.revenue | numberToReal }}
                  </div>
                </div> -->
              </div>

              <!-- <div class="hero__line hero__period">
                <span><b>Período:</b> {{ shortRange(safeKpis.period.start, safeKpis.period.end) }}</span>
                <span class="dot">•</span>
                <span class="muted">Comparando com: {{ shortRange(safeKpis.previous.period.from, safeKpis.previous.period.to) }}</span>
              </div> -->
            </div>

            <!-- Health Score -->
            <div class="hero__right">
              <div class="health">
                <div class="health__label">
									<i class="pi pi-verified"></i>
									Saúde
								</div>

                <div class="health__score" :class="severityClass(safeKpis.health_score.severity)">
                  <div class="health__score__value">
                    {{ safeKpis.health_score.score }}/100
                  </div>
                  <div class="health__score__text">
                    {{ safeKpis.health_score.label }}
                  </div>
                </div>

                <ul class="health__reasons">
                  <li v-for="(r, idx) in (safeKpis.health_score.reasons || []).slice(0, 3)" :key="idx">
                    {{ r }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Summary Insights (1 card só, bem executivo) -->
        <div class="panel summary">
          
          <div class="panel__header row-between">
            <h3><i class="pi pi-lightbulb"></i> Insights</h3>
            <span class="severity-pill" :class="severityClass(safeKpis.insights.severity)">
              {{ severityLabel(safeKpis.insights.severity) }}
            </span>
          </div>

          <div class="panel__body">
            <!-- Top warnings (se tiver) -->
            <div v-if="safeKpis.insights.warnings && safeKpis.insights.warnings.length" class="list-block warning">
              <div class="list-title">Alertas</div>
              <ul>
                <li v-for="(t, idx) in safeKpis.insights.warnings.slice(0, 3)" :key="'w'+idx">{{ t }}</li>
              </ul>
            </div>

            <!-- Top positives -->
            <div v-if="safeKpis.insights.positives && safeKpis.insights.positives.length" class="list-block positive">
              <div class="list-title">Pontos positivos</div>
              <ul>
                <li v-for="(t, idx) in safeKpis.insights.positives.slice(0, 2)" :key="'p'+idx">{{ t }}</li>
              </ul>
            </div>
          
            <div class="panel__header row-between mt">
              <h3><i class="pi pi-file"></i> Resumo</h3>
            </div>
            <p class="summary__text">{{ safeKpis.insights.summary }}</p>

          </div>

        </div>
      </div>

      <!-- KPI GRID -->
      <div class="kpi-grid kpi-grid--heading">
        <span class="kpi__title"><i class="pi pi-filter"></i> Funil de vendas digital</span>
      </div>
      <div class="kpi-grid kpi-grid--5">
        <div class="panel kpi kpi--arrow">
          <div class="kpi__head">
            <span class="kpi__title"><i class="pi pi-credit-card"></i> Investimento <ActiveIntegrationsIcons small only="ads" /></span>
            <span v-if="safeKpis.delta" class="delta-badge" :class="deltaBadgeClass('cost', safeKpis.delta.cost_pct)">
              <i :class="deltaSymbolClass('cost', safeKpis.delta.cost_pct)"></i>
              {{ formatSignedPct(safeKpis.delta.cost_pct) }}
            </span>
          </div>
          <div class="kpi__value">{{ safeKpis.current.cost | numberToReal }}</div>
          <div class="kpi__foot muted">vs período anterior</div>
        </div>

        <div class="panel kpi kpi--arrow">
          <div class="kpi__head">
            <span class="kpi__title"><i class="pi pi-eye"></i> Impressões <ActiveIntegrationsIcons small only="ads" /></span>
            <span v-if="safeKpis.delta" class="delta-badge" :class="deltaBadgeClass('impressions', safeKpis.delta.impressions_pct)">
              <i :class="deltaSymbolClass('impressions', safeKpis.delta.impressions_pct)"></i>
              {{ formatSignedPct(safeKpis.delta.impressions_pct) }}
            </span>
          </div>
          <div class="kpi__value">{{ formatInt(safeKpis.current.impressions) }}</div>
          <div class="kpi__foot muted">vs período anterior</div>
        </div>

        <div class="panel kpi kpi--arrow">
          <div class="kpi__head">
            <span class="kpi__title"><i class="pi pi-arrow-circle-right"></i> Cliques <ActiveIntegrationsIcons small only="ads" /></span>
            <span v-if="safeKpis.delta" class="delta-badge" :class="deltaBadgeClass('clicks', safeKpis.delta.clicks_pct)">
              <i :class="deltaSymbolClass('clicks', safeKpis.delta.clicks_pct)"></i>
              {{ formatSignedPct(safeKpis.delta.clicks_pct) }}
            </span>
          </div>
          <div class="kpi__value">{{ formatInt(safeKpis.current.clicks) }}</div>
          <div class="kpi__foot muted">vs período anterior</div>
        </div>

        <div class="panel kpi kpi--arrow">
          <div class="kpi__head">
            <span class="kpi__title"><i class="pi pi-shopping-cart"></i> Conversões <ActiveIntegrationsIcons small only="ads" /></span>
            <span v-if="safeKpis.delta" class="delta-badge" :class="deltaBadgeClass('conversions', safeKpis.delta.conversions_pct)">
              <i :class="deltaSymbolClass('conversions', safeKpis.delta.conversions_pct)"></i>
              {{ formatSignedPct(safeKpis.delta.conversions_pct) }}
            </span>
          </div>
          <div class="kpi__value">{{ formatNumber(safeKpis.current.conversions, 2) }}</div>
          <div class="kpi__foot muted">vs período anterior</div>
        </div>
      
        <div class="panel kpi">
          <div class="kpi__head">
            <span class="kpi__title"><i class="pi pi-dollar"></i> Receita total <ActiveIntegrationsIcons small :only="safeKpis.current.with_sales == true ? 'ecommerce' : 'ads'" /></span>
            <span v-if="safeKpis.delta" class="delta-badge" :class="deltaBadgeClass('revenue', safeKpis.delta.revenue_pct)">
              <i :class="deltaSymbolClass('revenue', safeKpis.delta.revenue_pct)"></i>
              {{ formatSignedPct(safeKpis.delta.revenue_pct) }}
            </span>
          </div>
          <div class="kpi__value">{{ safeKpis.current.revenue | numberToReal }}</div>
          <div class="kpi__foot muted">vs período anterior</div>
        </div>
      </div>

      <div class="kpi-grid kpi-grid--heading">
        <span class="kpi__title"><i class="pi pi-gauge"></i> Indicadores</span>
      </div>
      <div class="kpi-grid">
        <div class="panel kpi">
          <div class="kpi__head">
            <span class="kpi__title">
              CTR
              <ActiveIntegrationsIcons small :only="'ads'" />
            </span>
            <button class="help-btn" @click="openHelp('ctr')">?</button>
          </div>
          <div class="kpi__value">{{ safeKpis.current.ctr | percentage }}</div>
          <div class="kpi__foot muted">qualidade do anúncio</div>
        </div>

        <div class="panel kpi">
          <div class="kpi__head">
            <span class="kpi__title">
              CPC
              <ActiveIntegrationsIcons small :only="'ads'" />
            </span>
            <button class="help-btn" @click="openHelp('cpc')">?</button>
          </div>
          <div class="kpi__value">{{ safeKpis.current.cpc | numberToReal }}</div>
          <div class="kpi__foot muted">custo por clique</div>
        </div>

        <div class="panel kpi">
          <div class="kpi__head">
            <span class="kpi__title">
              CPA
              <ActiveIntegrationsIcons small :only="safeKpis.current.with_sales == true ? null : 'ads'" />
            </span>
            <button class="help-btn" @click="openHelp('cpa')">?</button>
          </div>
          <div class="kpi__value">{{ safeKpis.current.cpa | numberToReal }}</div>
          <div class="kpi__foot muted">custo por conversão</div>
        </div>

        <div class="panel kpi">
          <div class="kpi__head">
            <span class="kpi__title">
              CPM
              <ActiveIntegrationsIcons small :only="'ads'" />
            </span>
            <button class="help-btn" @click="openHelp('cpm')">?</button>
          </div>
          <div class="kpi__value">{{ safeKpis.current.cpm | numberToReal }}</div>
          <div class="kpi__foot muted">custo por 1.000 impressões</div>
        </div>
      </div>
      
      <div v-for="kpi in safeKpis.by_channel_type" v-bind:key="kpi.channel_type">
        <div class="kpi-grid kpi-grid--heading">
          <span class="kpi__title"><i class="pi pi-gauge"></i> {{kpi.channel_type_label}}</span>
        </div>
        <div class="kpi-grid kpi-grid--5">
          <div class="panel kpi kpi--arrow">
            <div class="kpi__head">
              <span class="kpi__title"><i class="pi pi-credit-card"></i> Investimento <ActiveIntegrationsIcons small only="ads" /></span>
              <!-- <span v-if="safeKpis.delta" class="delta-badge" :class="deltaBadgeClass('cost', safeKpis.delta.cost_pct)">
                <i :class="deltaSymbolClass('cost', safeKpis.delta.cost_pct)"></i>
                {{ formatSignedPct(safeKpis.delta.cost_pct) }}
              </span> -->
            </div>
            <div class="kpi__value">{{ kpi.cost | numberToReal }}</div>
            <!-- <div class="kpi__foot muted">vs período anterior</div> -->
          </div>

          <div class="panel kpi kpi--arrow">
            <div class="kpi__head">
              <span class="kpi__title"><i class="pi pi-eye"></i> Impressões <ActiveIntegrationsIcons small only="ads" /></span>
              <!-- <span v-if="safeKpis.delta" class="delta-badge" :class="deltaBadgeClass('impressions', safeKpis.delta.impressions_pct)">
                <i :class="deltaSymbolClass('impressions', safeKpis.delta.impressions_pct)"></i>
                {{ formatSignedPct(safeKpis.delta.impressions_pct) }}
              </span> -->
            </div>
            <div class="kpi__value">{{ formatInt(kpi.impressions) }}</div>
            <!-- <div class="kpi__foot muted">vs período anterior</div> -->
          </div>

          <div class="panel kpi kpi--arrow">
            <div class="kpi__head">
              <span class="kpi__title"><i class="pi pi-arrow-circle-right"></i> Cliques <ActiveIntegrationsIcons small only="ads" /></span>
              <!-- <span v-if="safeKpis.delta" class="delta-badge" :class="deltaBadgeClass('clicks', safeKpis.delta.clicks_pct)">
                <i :class="deltaSymbolClass('clicks', safeKpis.delta.clicks_pct)"></i>
                {{ formatSignedPct(safeKpis.delta.clicks_pct) }}
              </span> -->
            </div>
            <div class="kpi__value">{{ formatInt(kpi.clicks) }}</div>
            <!-- <div class="kpi__foot muted">vs período anterior</div> -->
          </div>

          <div class="panel kpi kpi--arrow">
            <div class="kpi__head">
              <span class="kpi__title"><i class="pi pi-shopping-cart"></i> Conversões <ActiveIntegrationsIcons small only="ads" /></span>
              <!-- <span v-if="safeKpis.delta" class="delta-badge" :class="deltaBadgeClass('conversions', safeKpis.delta.conversions_pct)">
                <i :class="deltaSymbolClass('conversions', safeKpis.delta.conversions_pct)"></i>
                {{ formatSignedPct(safeKpis.delta.conversions_pct) }}
              </span> -->
            </div>
            <div class="kpi__value">{{ formatNumber(kpi.conversions, 2) }}</div>
            <!-- <div class="kpi__foot muted">vs período anterior</div> -->
          </div>
        
          <div class="panel kpi">
            <div class="kpi__head">
              <span class="kpi__title"><i class="pi pi-dollar"></i> Receita total <ActiveIntegrationsIcons small only="'ads'" /></span>
              <!-- <span v-if="safeKpis.delta" class="delta-badge" :class="deltaBadgeClass('revenue', safeKpis.delta.revenue_pct)">
                <i :class="deltaSymbolClass('revenue', safeKpis.delta.revenue_pct)"></i>
                {{ formatSignedPct(safeKpis.delta.revenue_pct) }}
              </span> -->
            </div>
            <div class="kpi__value">{{ kpi.conversions_value | numberToReal }}</div>
            <!-- <div class="kpi__foot muted">vs período anterior</div> -->
          </div>
        </div>
      </div>
      

      <!-- DETAILS (highlights full) -->
      <div class="panel details">
        <div class="panel__header row-between">
          <h3 class="panel__title">Detalhes do período</h3>
          <button class="link-btn" @click="openHelp('roas')">O que é ROAS?</button>
        </div>

        <div class="panel__body">
          <ul class="details__list">
            <li v-for="(t, idx) in safeKpis.insights.highlights" :key="idx">
              {{ t }}
            </li>
          </ul>

          <!-- Benchmarks (opcional, discreto) -->
          <div v-if="safeKpis.benchmarks" class="benchmarks">
            <div class="benchmarks__title">Referências (padrão)</div>
            <div class="benchmarks__items">
              <div class="bench-item">
                <b>ROAS</b>
                <span>crítico &lt; {{ safeKpis.benchmarks.roas.critical_below }}</span>
                <span>bom ≥ {{ safeKpis.benchmarks.roas.good_above }}</span>
              </div>
              <div class="bench-item">
                <b>CTR</b>
                <span>ruim &lt; {{ (safeKpis.benchmarks.ctr.bad_below).toFixed(1) }}%</span>
                <span>bom ≥ {{ (safeKpis.benchmarks.ctr.good_above).toFixed(1) }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- HELP MODAL -->
      <div v-if="helpOpen" class="help-modal-overlay" @click.self="closeHelp">
        <div class="help-modal">
          <div class="help-modal__header">
            <div class="help-modal__title">{{ (activeHelp.label) ? activeHelp.label : 'Ajuda' }}</div>
            <button class="help-modal__close" @click="closeHelp">✕</button>
          </div>

          <div class="help-modal__body" v-if="activeHelp">
            <p class="muted">{{ activeHelp.description }}</p>

            <div v-if="activeHelp.formula" class="help-box">
              <div class="help-box__label">Fórmula</div>
              <div class="help-box__value">{{ activeHelp.formula }}</div>
            </div>

            <div v-if="activeHelp.why_it_matters" class="help-box">
              <div class="help-box__label">Por que importa</div>
              <div class="help-box__value">{{ activeHelp.why_it_matters }}</div>
            </div>

            <div v-if="activeHelp.note" class="help-note">
              {{ activeHelp.note }}
            </div>
          </div>

          <div class="help-modal__body" v-else>
            <p class="muted">Métrica não encontrada.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import FilterDatepicker from "@/components/filter-datepicker/FilterDatepicker.vue";
import FilterCampaigns from "@/components/filter-campaigns/FilterCampaigns.vue";
// import FilterAffiliate from "@/components/filter-affiliate/FilterAffiliate.vue";

import { numberToReal, numberToRealWitoutSymbol } from "@/utils/money";
import { percentage } from "@/utils/masks";
import { fetchMidiaSummary, fetchMidiaTotals, fetchMidiaKpis } from "@/api/midia";
import ActiveIntegrationsIcons from "@/components/active-integrations/ActiveIntegrationsIcons.vue";

export default {
  filters: {
    numberToReal,
    numberToRealWitoutSymbol,
    percentage,
  },
  components: {
    // FilterAffiliate,
    ActiveIntegrationsIcons,
    FilterDatepicker,
    FilterCampaigns,
  },
  data() {
    return {
      start: null,
      end: null,
      affiliateIds: null,
      campaignIds: null,

      helpOpen: false,
      helpKey: null,

      ecommerceIntegrations: [],
      adsIntegrations: [],
    };
  },
  computed: {
    ...mapState({
      summary: (state) => state.midia.summary,
      totals: (state) => state.midia.totals,
      kpis: (state) => state.midia.kpis,
      textHints: (state) => state.midia.textHints,
      integrations: (state) => state.integrations.integrations,
    }),

		safeKpis() {
			// evita crash no primeiro render
			const k = this.kpis || {};
			return {
				period: k.period || { start: null, end: null },
				current: k.current || {},
				previous: k.previous || { period: { from: null, to: null } },
				delta: k.delta || {},
				health_score: k.health_score || { score: 0, label: "-", severity: "warning", reasons: [] },
				insights: k.insights || { severity: "warning", summary: "", highlights: [], warnings: [], positives: [] },
				benchmarks: k.benchmarks || null,
				metrics_help: k.metrics_help || {},
				by_channel_type: k.by_channel_type || {},
			};
		},

    activeHelp() {
      if (!this.textHints) return null;
      return this.textHints[this.helpKey] || null;
    },
  },
  mounted() {
    this.loadAll();
  },
  methods: {
    fetchMidiaSummary,
    fetchMidiaTotals,
    fetchMidiaKpis,

    loadAll() {
      // this.fetchMidiaSummary(this.start, this.end, {
      //   affiliate_id: this.affiliateIds,
      // });
      // this.fetchMidiaTotals(this.start, this.end, {
      //   affiliate_id: this.affiliateIds,
      // });
      this.fetchMidiaKpis(this.start, this.end, {
        affiliate_id: this.affiliateIds,
        campaign_id: this.campaignIds,
      });
    },

    changeCampaigns(ids) {
      this.campaignIds = ids;
      this.loadAll();
    },

    setDataFilter({ start, end }) {
      this.start = start;
      this.end = end;
      this.loadAll();
    },

    // ---------- HELP ----------
    openHelp(key) {
      this.helpKey = key;
      this.helpOpen = true;
    },
    closeHelp() {
      this.helpOpen = false;
      this.helpKey = null;
    },

    // ---------- FORMATTING ----------
    formatNumber(v, digits = 2) {
      const n = Number(v || 0);
      return n.toLocaleString("pt-BR", { minimumFractionDigits: digits, maximumFractionDigits: digits });
    },
    formatInt(v) {
      const n = Number(v || 0);
      return Math.round(n).toLocaleString("pt-BR");
    },
    formatSignedPct(v) {
      if (v === null || v === undefined) return "";
      const n = Number(v);
      const sign = n >= 0 ? "+" : "-";
      return `${sign}${Math.abs(n).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
    },
    shortRange(from, to) {
      return `${this.shortDate(from)} – ${this.shortDate(to)}`;
    },
    shortDate(iso) {
      if (!iso) return "";
      const [y, m, d] = iso.split("-");
			console.log('shotDate y', y);
      const months = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];
      return `${d}/${months[Number(m) - 1]}`;
    },

    // delta “bom vs ruim” por métrica
    deltaBadgeClass(metric, pct) {
      if (pct === null || pct === undefined) return "is-muted";

      const n = Number(pct);
      const lowerIsBetter = ["cost", "cpc", "cpa", "cpm"];
      const isGood = lowerIsBetter.includes(metric) ? (n <= 0) : (n >= 0);

      return isGood ? "is-good" : "is-bad";
    },

    // delta “bom vs ruim” por métrica
    deltaSymbolClass(metric, pct) {
      if (pct === null || pct === undefined) return "is-muted";

      const n = Number(pct);
      const lowerIsBetter = ["cost", "cpc", "cpa", "cpm"];
      const isGood = lowerIsBetter.includes(metric) ? (n <= 0) : (n >= 0);

      return isGood ? "pi pi-sort-up-fill" : "pi pi-sort-down-fill";
    },

    severityClass(sev) {
      if (sev === "critical") return "sev-critical";
      if (sev === "warning") return "sev-warning";
      return "sev-ok";
    },
    severityLabel(sev) {
      if (sev === "critical") return "Crítico";
      if (sev === "warning") return "Atenção";
      return "OK";
    },
  },
	watch: {
		summary(data) {
			console.log('summary data', data)
		},
		kpis(data) {
			console.log('kpis data', data)
		},

    integrations(data) {
      console.log('watch integrations', data);
      this.ecommerceIntegrations = data.filter(i => i.category === 'ecommerce');
      this.adsIntegrations = data.filter(i => i.category === 'ads');
    },
	}
};
</script>

<style lang="scss" scoped>
/* =========================================================
   Ajuste visual “clean dashboard” (tipo a imagem referência)
   ========================================================= */
.mt {
  margin-top: 1rem;
}

.box-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 16px;

  &__childs {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
  }
}

/* wrapper */
.midia-kpis-page {
  /* Tokens */
  --bg: #f6f8fb;
  --card: #ffffff;
  --text: #0f172a;
  --muted: #3b495d;

  --border: rgba(15, 23, 42, 0.08);
  --border-2: rgba(15, 23, 42, 0.06);

  --shadow-sm: 0 6px 18px rgba(15, 23, 42, 0.08);
  --shadow: 0 14px 40px rgba(15, 23, 42, 0.10);

  --radius: 18px;
  --radius-sm: 14px;

  --good: #16a34a;
  --good-bg: rgba(22, 163, 74, 0.10);
  --warn: #f59e0b;
  --bad: #ef4444;

  color: var(--text);

  .dot { margin: 0 8px; opacity: .55; }
  .muted { color: var(--muted); opacity: 1; }

  /* grid */
  .hero-grid {
    display: grid;
    grid-template-columns: 1.6fr 1fr;
    gap: 16px;
    margin-top: 12px;

    @media (max-width: 1100px) {
      grid-template-columns: 1fr;
    }
  }

  /* card base (clean white) */
  .panel {
    background: var(--card);
    border-radius: var(--radius);
    padding: 18px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
    position: relative;
  }

  .panel__header {
    margin-bottom: 12px;
    h2, h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 300;
      color: var(--text);
    }
  }
  .panel__body { font-size: 13px; }

  .row-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  /* =============================
     HERO (ROAS + Saúde)
     ============================= */
  .hero {
    // box-shadow: var(--shadow); /* hero com mais destaque */

    .hero__top {
      display: grid;
      grid-template-columns: 1.25fr 1fr;
      gap: 16px;

      @media (max-width: 900px) {
        grid-template-columns: 1fr;
      }

      .hero__left {
        display: flex;
        flex-direction: column;
      }
    }

    .hero__label {
      font-size: 16px;
      font-weight: 300;
      // letter-spacing: .14em;
      // text-transform: uppercase;
      // color: var(--muted);
      color: var(--muted);
      display: inline-flex;
      align-items: center;
      gap: 10px;
    }

    .hero__value-row {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-top: 10px;
      flex-wrap: wrap;
    }

    .hero__value {
      font-size: 56px;
      font-weight: 500;
      letter-spacing: -0.04em;
      line-height: 1;
      color: var(--text);
    }

    .hero__sub {
      // margin-top: 20px;
      font-size: 13px;
      color: var(--muted);

      b { color: var(--text); }
    }

    .hero__points {
      margin-top: 17px;
      font-size: 13px;
      display: flex;
      justify-content: space-between;
      gap: 10px;
      color: var(--muted);

      > div {
        width: 100%;
      }

      b { color: var(--text); }

      .hero__value {
        font-size: 22px;
        margin-top: 14px;
      }
    }

    .hero__line {
      margin-top: 20px;
			padding-left: 17px;
      font-size: 13px;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      color: var(--muted);

      b { color: var(--text); }
    }

    // .hero__period {
    //   margin-top: 14px;
		// 	padding-left: 14px;
    //   font-size: 12px;
    //   color: var(--muted);
    // }

    /* Saúde - mais “card dentro do card” */
    .health {
      // background: $bg-gradient-highlight;
      background: #fff;
      box-shadow: 0 10px 24px rgba(15, 23, 42, 0.1);
      border-radius: var(--radius);
      padding: 14px;
      border: 1px solid #f4f2f8;

      .health__label {
        font-size: 16px;
        font-weight: 300;
        // letter-spacing: .14em;
        // text-transform: uppercase;
        color: var(--muted);
      }

      .health__score {
        margin-top: 10px;
        border-radius: var(--radius-sm);
        padding: 12px 12px;
        background: #fff;
        border: 1px solid var(--border-2);

        .health__score__value {
          font-size: 20px;
          font-weight: 600;
          letter-spacing: -0.02em;
          color: var(--text);
        }
        .health__score__text {
          margin-top: 2px;
          font-size: 12px;
          color: var(--muted);
        }
      }

      .health__reasons {
        margin: 12px 0 0;
        padding-left: 18px;
        font-size: 12px;
        color: var(--muted);

        li { margin-bottom: 8px; line-height: 1.35; }
      }
    }
  }

  /* =============================
     SUMMARY (alertas/positivos)
     ============================= */
  .summary {
    // background: $bg-gradient-highlight;
    background: #fff;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.1);
  }
  
  .summary__text {
    margin: 0 0 12px;
    color: var(--text);
    line-height: 1.45;
    font-weight: 400;
  }

  .list-block {
    margin-top: 12px;
    border-radius: var(--radius);
    padding: 12px;
    border: 1px solid var(--border-2);
    background: #fbfcfe;

    .list-title {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 8px;
      color: var(--muted);
      // text-transform: uppercase;
      // letter-spacing: .14em;
    }

    ul { margin: 18px 0 0 0; padding-left: 18px; list-style: circle; }
    li { margin-bottom: 8px; line-height: 1.35; color: var(--text); }
  }

  /* “Insight” vibe: verde clarinho e suave */
  .list-block.positive {
    background: rgba(22, 163, 74, 0.06);
    border-color: rgba(22, 163, 74, 0.18);
  }

  .list-block.warning {
    background: rgba(245, 158, 11, 0.06);
    border-color: rgba(245, 158, 11, 0.20);
  }

  /* =============================
     KPI GRID (cards pequenos)
     ============================= */
  .kpi-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
    margin-top: 14px;
    
    &--5 {
      grid-template-columns: repeat(5, 1fr);

      @media (max-width: 1100px) { grid-template-columns: repeat(2, 1fr); }
      @media (max-width: 520px) { grid-template-columns: 1fr; }
    }

    &--heading {
      margin-top: 28px;
    }

    @media (max-width: 1100px) { grid-template-columns: repeat(2, 1fr); }
    @media (max-width: 520px) { grid-template-columns: 1fr; }
  }

  .kpi {
    padding: 16px;
    border-radius: var(--radius);
    background: #fff;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);

    &--transparent {
      background: transparent;
      border: none;
      box-shadow: none;
      padding: 0;
    }

    &--arrow {
      position: relative;

      &::before {
        color: var(--muted);
        content: "\e91b";
        font-family: 'primeicons';
        font-size: 12px;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        display: inline-block;
        -webkit-font-smoothing: antialiased;

        background: white;
        box-shadow: 4px 0 4px rgba(0,0,0,.1);
        border-radius: 8px;
        height: 32px;
        padding: 10px 20px 10px 7px;
        position: absolute;
        right: -16px;
        top: calc(50% - 15px);
        width: 30px;
        z-index: 1;
      }
    }

    .kpi__head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      margin-bottom: 10px;
    }

    .kpi__title {
      font-size: 16px;
      font-weight: 300;
      // color: var(--muted);
      // text-transform: uppercase;
      // letter-spacing: .14em;
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }

    .kpi__value {
      font-size: 22px;
      font-weight: 500;
      letter-spacing: -0.02em;
      color: var(--text);
    }

    .kpi__foot {
      align-items: center;
      display: flex;
      gap: 0;
      margin-top: 8px;
      font-size: 12px;
      color: var(--muted);
    }
  }

  /* =============================
     Botão de ajuda (pill clean)
     ============================= */
  .help-btn {
    width: 20px;
    height: 20px;
    border-radius: 999px;
    border: 1px solid var(--border);
    background: var(--muted);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    line-height: 1;
    transition: transform .12s ease, box-shadow .12s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 10px 18px rgba(15, 23, 42, 0.10);
      // color: var(--text);
    }
  }

  /* =============================
     DETAILS / lista
     ============================= */
  .details { margin-top: 14px; }

  .details__list {
    margin: 0;
    padding-left: 18px;
    padding-top: 18px;
		list-style: circle;

    li {
      margin-bottom: 10px;
      line-height: 1.45;
      color: var(--text);
    }
  }

  .benchmarks {
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid var(--border-2);

    .benchmarks__title {
      font-size: 11px;
      font-weight: 600;
      color: var(--muted);
      text-transform: uppercase;
      letter-spacing: .14em;
      margin-bottom: 10px;
    }

    .benchmarks__items {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;

      @media (max-width: 900px) {
        grid-template-columns: 1fr;
      }
    }

    .bench-item {
      display: flex;
      flex-direction: column;
      gap: 4px;
      font-size: 12px;
      color: var(--muted);

      b { color: var(--text); }
    }
  }

  /* =============================
     Badges (igual referência: verde + seta)
     ============================= */
  .delta-badge {
    font-size: 12px;
    font-weight: 600;
    padding: 6px 10px;
    border-radius: 999px;
    border: 1px solid var(--border);
    background: #fff;
    color: var(--muted);
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;

    &.is-good {
      color: var(--good);
      border-color: rgba(22, 163, 74, 0.22);
      background: rgba(22, 163, 74, 0.08);
    }

    &.is-bad {
      color: var(--bad);
      border-color: rgba(239, 68, 68, 0.22);
      background: rgba(239, 68, 68, 0.08);
    }

    &.is-muted {
      background: #fbfcfe;
      color: var(--muted);
    }
  }

  .severity-pill {
    font-size: 12px;
    font-weight: 600;
    padding: 6px 12px;
    border-radius: 999px;
    border: 1px solid var(--border);
    background: #fbfcfe;
    color: var(--muted);
  }

  .sev-critical {
		color: var(--bad) !important; border-color: rgba(239, 68, 68, 0.22) !important; background: rgba(239, 68, 68, 0.08) !important;
		* { color: var(--bad) !important; }
	}
  .sev-warning {
		color: var(--warn) !important; border-color: rgba(245, 158, 11, 0.22) !important; background: rgba(245, 158, 11, 0.08) !important;
		* { color: var(--warn) !important; }
	}
  .sev-ok {
		color: var(--good !important); border-color: rgba(22, 163, 74, 0.22) !important; background: rgba(22, 163, 74, 0.08) !important;
		* { color: var(--good) !important; }
	}

  /* =============================
     Modal clean (sem blur futurista)
     ============================= */
  .help-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, .45);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px;
    z-index: 9999;
  }

  .help-modal {
    width: 560px;
    max-width: 100%;
    background: #fff;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    overflow: hidden;
    box-shadow: 0 30px 80px rgba(15, 23, 42, 0.22);
  }

  .help-modal__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    border-bottom: 1px solid var(--border-2);
    background: #fbfcfe;
  }

  .help-modal__title { font-weight: 600; color: var(--text); }

  .help-modal__close {
    border: 1px solid var(--border);
    background: #fff;
    cursor: pointer;
    font-size: 14px;
    width: 34px;
    height: 34px;
    border-radius: 12px;
    color: var(--muted);
    transition: transform .12s ease;

    &:hover { transform: translateY(-1px); color: var(--text); }
  }

  .help-modal__body { padding: 16px; font-size: 13px; color: var(--text); }

  .help-box {
    margin-top: 12px;
    border: 1px solid var(--border-2);
    border-radius: var(--radius);
    padding: 12px;
    background: #fbfcfe;
  }

  .help-box__label {
    font-size: 11px;
    font-weight: 600;
    color: var(--muted);
    text-transform: uppercase;
    letter-spacing: .14em;
    margin-bottom: 6px;
  }

  .help-note {
    margin-top: 12px;
    font-size: 12px;
    color: var(--muted);
  }

  .link-btn {
    border: none;
    background: transparent;
    color: var(--muted);
    cursor: pointer;
    font-size: 12px;
    font-weight: 300;
    text-decoration: none;
    padding: 6px 8px;
    border-radius: 10px;

    &:hover { background: rgba(148, 157, 151, 0.08); }
  }

  .empty-state { margin-top: 12px; }
}
</style>